import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { PessoaContatoModule } from '../../../pessoa/contato';
import { LeadContatoComponent } from './lead-contato.component';
import { LeadContatoTableComponent } from './table';
import { LeadContatoFormComponent } from './form';
import { LeadContatoFormModalComponent } from './form-modal';
import { LeadContatoUnicoComponent } from './unico';
import { LeadContatoListGroupComponent } from './list-group';

@NgModule({
    imports: [
        SharedModule,
        PessoaContatoModule
    ],
    declarations: [
        LeadContatoComponent,
        LeadContatoTableComponent,
        LeadContatoFormComponent,
        LeadContatoFormModalComponent,
        LeadContatoUnicoComponent,
        LeadContatoListGroupComponent,
    ],
    exports: [
        LeadContatoComponent,
        LeadContatoUnicoComponent,
        LeadContatoFormModalComponent,
        LeadContatoListGroupComponent
    ]
})
export class LeadContatoModule { }
